var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-slider',{attrs:{"label":"Label"}}),_c('v-slider',{attrs:{"inverse-label":"","label":"Inverse label","value":"30","hide-details":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }